// src/ChatInput.tsx
import React from "react";

interface Props {
  input: string;
  setInput: (val: string) => void;
  sendMessage: () => void;
  colors: any;
}

const ChatInput: React.FC<Props> = ({ input, setInput, sendMessage, colors }) => {
  return (
    <div
      style={{
        display: "flex",
        padding: 15,
        borderTop: "1px solid #ddd",
        backgroundColor: colors.inputBg,
      }}
    >
      <input
        type="text"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        placeholder="Type your message..."
        style={{
          flexGrow: 1,
          padding: "10px 15px",
          borderRadius: 8,
          border: "1px solid #ccc",
          fontSize: 16,
          backgroundColor: colors.inputBg,
          color: colors.text,
        }}
        onKeyPress={(e) => e.key === "Enter" && sendMessage()}
      />
      <button
        onClick={sendMessage}
        style={{
          padding: "10px 20px",
          marginLeft: 10,
          backgroundColor: colors.headerBg,
          color: colors.headerText,
          border: "none",
          borderRadius: 8,
          cursor: "pointer",
          fontSize: 16,
        }}
      >
        Send
      </button>
    </div>
  );
};

export default ChatInput;
